export default __webpack_public_path__ + "static/media/gaiter.04251ee3.jpg";